import { IPagination } from 'app/types/common';

export interface IConnectionsState {
  readonly connectionsById?: any;
  readonly connectionIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectConnectionLoading?: boolean;
  readonly showAddConnection?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationConnectionIds?: string[];
  readonly currentConnectionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IConnectionsSelector
  extends IConnectionsState {
  readonly currentConnection?: any;
  readonly currentFormConnection?: any;
  readonly connectionsFilteredByOrganisationInSelectFormat?: any;
  readonly connectionsByTagAndIdInSelectFormat?: any;
  readonly connectionsByIdInSelectFormat?: any;
  readonly connectionsFilteredByCompetitionInSelectFormat?: any;
  readonly connectionsFilteredByIdInSelectFormat?: any;
}

export enum ConnectionsActionTypes {
  GET_ALL_CONNECTIONS_REQUESTED = 'redux-app/connections/GET_ALL_CONNECTIONS_REQUESTED',
  GET_ALL_CONNECTIONS_PENDING = 'redux-app/connections/GET_ALL_CONNECTIONS_PENDING',
  GET_ALL_CONNECTIONS_SUCCESS = 'redux-app/connections/GET_ALL_CONNECTIONS_SUCCESS',
  GET_ALL_CONNECTIONS_FAIL = 'redux-app/connections/GET_ALL_CONNECTIONS_FAIL',
  GET_CONNECTION_REQUESTED = 'redux-app/connections/GET_CONNECTION_REQUESTED',
  GET_CONNECTION_PENDING = 'redux-app/connections/GET_CONNECTION_PENDING',
  GET_CONNECTION_SUCCESS = 'redux-app/connections/GET_CONNECTION_SUCCESS',
  GET_CONNECTION_FAIL = 'redux-app/connections/GET_CONNECTION_FAIL',
  UPDATE_CONNECTION_REQUESTED = 'redux-app/connections/UPDATE_CONNECTION_REQUESTED',
  UPDATE_CONNECTION_PENDING = 'redux-app/connections/UPDATE_CONNECTION_PENDING',
  UPDATE_CONNECTION_SUCCESS = 'redux-app/connections/UPDATE_CONNECTION_SUCCESS',
  UPDATE_CONNECTION_FAIL = 'redux-app/connections/UPDATE_CONNECTION_FAIL',
  CREATE_CONNECTION_REQUESTED = 'redux-app/connections/CREATE_CONNECTION_REQUESTED',
  CREATE_CONNECTION_PENDING = 'redux-app/connections/CREATE_CONNECTION_PENDING',
  CREATE_CONNECTION_SUCCESS = 'redux-app/connections/CREATE_CONNECTION_SUCCESS',
  CREATE_CONNECTION_FAIL = 'redux-app/connections/CREATE_CONNECTION_FAIL',
  DELETE_CONNECTION_REQUESTED = 'redux-app/connections/DELETE_CONNECTION_REQUESTED',
  DELETE_CONNECTION_PENDING = 'redux-app/connections/DELETE_CONNECTION_PENDING',
  DELETE_CONNECTION_SUCCESS = 'redux-app/connections/DELETE_CONNECTION_SUCCESS',
  DELETE_CONNECTION_FAIL = 'redux-app/connections/DELETE_CONNECTION_FAIL',
  SELECT_CONNECTION_REQUESTED = 'redux-app/connections/SELECT_CONNECTION_REQUESTED',
}

export default null;
